<template>
  <ion-page>
    <main-header :back-href="backHref"></main-header>
    <ion-content padding>
      <add-stripe-card @complete="handleStripeAdded"></add-stripe-card>
    </ion-content>
  </ion-page>
</template>

<script>
import AddStripeCard from "@/components/App/AddStripeCard";
import { mapGetters } from "vuex";

export default {
  title: "Add Credit Card",

  components: {
    "add-stripe-card": AddStripeCard
  },

  methods: {
    handleStripeAdded(stripeCardId) {
      this.$router
        .push({ name: "App: Order Payment", params: { stripeCardId } })
        .catch(e => e);
    }
  },

  computed: {
    ...mapGetters("auth", ["user"]),

    backHref() {
      // right now we don't have access to the user's card list, so this is a TODO
      // it should go back to order payment if they have cards, back to order review if
      // they don't. Right now its sometimes gonna jump back two spaces, but that's
      // ok for now
      return this.$router.resolve({
        name: "App: Order Review and Confirm"
      }).href;
    }
  }
};
</script>
